import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

const PartnerSignupContext = createContext();

export const usePartnerSignup = () => {
  const context = useContext(PartnerSignupContext);
  if (!context) {
    throw new Error('usePartnerSignup must be used within PartnerSignupProvider');
  }
  return context;
};

export const PartnerSignupProvider = ({ children }) => {
  // Use ref to store files persistently across re-renders
  const filesRef = useRef([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  // Log provider lifecycle
  useEffect(() => {
    console.log('[CONTEXT] PartnerSignupProvider mounted');
    return () => {
      console.log('[CONTEXT] PartnerSignupProvider unmounting');
    };
  }, []);

  // Log state changes and sync to ref
  useEffect(() => {
    console.log('[CONTEXT] uploadedFiles state changed:', uploadedFiles.length, 'files');
    console.log('[CONTEXT] Files in ref:', filesRef.current.length);
    filesRef.current = uploadedFiles;
  }, [uploadedFiles]);

  // Custom setter that updates both state and ref
  const setUploadedFilesWithRef = (files) => {
    console.log('[CONTEXT] setUploadedFiles called with:', files.length, 'files');
    filesRef.current = files;
    setUploadedFiles(files);
  };

  const clearFiles = () => {
    console.log('[CONTEXT] Clearing files');
    filesRef.current = [];
    setUploadedFiles([]);
  };

  const value = {
    uploadedFiles,
    setUploadedFiles: setUploadedFilesWithRef,
    clearFiles
  };

  return (
    <PartnerSignupContext.Provider value={value}>
      {children}
    </PartnerSignupContext.Provider>
  );
};
